import { buttonMessages } from "@dashboard/intl";
import { Button, type ButtonProps } from "@saleor/macaw-ui-next";
import { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";

interface BackButtonProps extends ButtonProps {
  children?: ReactNode;
}

// 모달 하단에서 창을 닫는 버튼이라 기본 문구를 '뒤로가기' 대신 '닫기'로 (2026-10-15 KST 수정)
const BackButton = ({ children, ...props }: BackButtonProps) => (
  <Button data-test-id="back" variant="secondary" {...props}>
    {children ?? <FormattedMessage {...buttonMessages.close} />}
  </Button>
);

BackButton.displayName = "BackButton";
export default BackButton;
